import { render } from "./LoginView.vue?vue&type=template&id=a1877e68"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Kos\\Downloads\\filemgr.mREaF3.2026-05-15_16_14_46\\vxadoor.pro\\hubuntu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__